import React from 'react';
import TextInput from './TextInput'; // Adjust the import path as needed

interface FormattedPhoneInputProps {
  label: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
}

const FormattedPhoneInput: React.FC<FormattedPhoneInputProps> = ({
  label,
  name,
  value,
  onChange,
  disabled = false,
  required = false,
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters

    if (inputValue.length > 10) {
      inputValue = inputValue.slice(0, 10); // Limit to 10 digits
    }

    let formattedValue = '';
    if (inputValue.length > 6) {
      formattedValue = `${inputValue.slice(0, 3)}-${inputValue.slice(
        3,
        6,
      )}-${inputValue.slice(6)}`;
    } else if (inputValue.length > 3) {
      formattedValue = `${inputValue.slice(0, 3)}-${inputValue.slice(3)}`;
    } else {
      formattedValue = inputValue;
    }

    onChange(formattedValue);
  };

  return (
    <TextInput
      label={label}
      name={name}
      value={value}
      maxLength={12} // 12 characters including dashes (XXX-XXX-XXXX)
      onChange={handleInputChange}
      disabled={disabled}
      required={required}
    />
  );
};

export default FormattedPhoneInput;
